import { Page } from 'components/layout/panel/Page/Page';
import { DatabaseBrowserContainer } from 'components/schoolDistricts/DatabaseBrowser/DatabaseBrowserContainer';
import { useTranslator } from 'components/shared/hooks';

import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import { Paper } from 'components/shared/surfaces/Paper/Paper';
import { replace } from 'utils/navigation/navigate';
import React, { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { DatabaseListViewState } from 'views/Panel/SchoolDistricts/DatabaseList/DatabaseList.types';

import { useStyles } from './DatabaseList.styles';

export const DatabaseListView: FC = () => {
  const [action, setAction] = useState(null);
  const trans = useTranslator();
  const classes = useStyles();
  const location = useLocation();
  const state = location.state as DatabaseListViewState | null;

  useEffect(() => {
    if (state && state.action) {
      setAction(state.action);
    }

    // replace state so the action will not be run after refreshing the page
    replace(location.pathname);
  }, [state, location.pathname]);

  return (
    <>
      <Breadcrumb label={trans('BREADCRUMB.SCHOOL-DISTRICTS.DATABASE')} static />

      <Page title={trans('SCHOOL_DISTRICTS.DATABASE.TITLE')}>
        <Paper innerSpacing={2} outerSpacing={[0, 2, 2]} className={classes.paper}>
          <DatabaseBrowserContainer initialAction={action} />
        </Paper>
      </Page>
    </>
  );
};
